
import type { PropType } from 'vue'

import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        type: {
            type: String as PropType<'green' | 'purple' | 'red' | 'downtime'>,
            default: 'green'
        }
    }
})
